import { IToken } from '@dokucoach/common-types';
import { MILLISECONDS_IN_A_SECOND } from 'constants/time';
import { useCallback, useState } from 'react';

export const TOKEN_KEY = 'token';
export const TOKEN_EXPIRES_AT_KEY = 'token.expiresAt';

export const getToken = (): IToken => {
  const item = localStorage.getItem(TOKEN_KEY) ?? '{}';

  if (item) {
    return JSON.parse(item) as IToken;
  }

  return {} as IToken;
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_EXPIRES_AT_KEY);
};

const useToken = () => {
  const saveToken = useCallback((token: IToken) => {
    localStorage.setItem(TOKEN_KEY, JSON.stringify(token));
    localStorage.setItem(
      TOKEN_EXPIRES_AT_KEY,
      JSON.stringify(new Date().getTime() + token.expiresIn * MILLISECONDS_IN_A_SECOND),
    );
    setToken(token);
  }, []);

  const [token, setToken] = useState<IToken>(getToken());
  return { setToken: saveToken, token, removeToken };
};

export default useToken;
